import { Tag } from '../../../../../components/Tag';
import { NetworkPriceStatus } from '../../types';
import styles from './NetworkPriceStatusTag.module.scss';

type NetworkPriceStatusTagProps = { priceStatus: NetworkPriceStatus | null };

// Same labels and colors as the price manager status tag.
const STATUS_TAG_SKINS: Record<NetworkPriceStatus, 'blue' | 'pink'> = {
  AUTO: 'blue',
  MANUAL: 'blue',
  ERP: 'blue',
  EDITADO: 'blue',
  OTIMIZADO: 'pink',
};

export const NetworkPriceStatusTag = ({ priceStatus }: NetworkPriceStatusTagProps) => {
  if (!priceStatus || !STATUS_TAG_SKINS[priceStatus]) return null;

  return (
    <Tag className={styles.tag} size="xsmall" skin={STATUS_TAG_SKINS[priceStatus]}>
      {priceStatus}
    </Tag>
  );
};
